jQuery(document).ready(function($) {
  // var $pHead = $("#page-head");
  // var $limit = $pHead.height();
  // $(window).on("scroll", function() {
  //   var $st = $(this).scrollTop();
  //   if ($st <= $limit) {
  //     $pHead.css({ opacity: 1 - $st / $limit });
  //   }
  // });

  $(".swipebox").swipebox();

  $(".wpcf7-list-item.first").addClass("checked");

  $(".wpcf7-list-item").click(function() {
    $(this).addClass("checked");
    $(this)
      .siblings()
      .removeClass("checked");
  });

  $(document).on("click", 'a[href^="#"]:not(".no-scroll")', function(event) {
    event.preventDefault();
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top - 0,
        },
        1050,
        // include easing.js for more control over ease
        "easeInOutQuart"
      );
  });

  $("#mobile-menu .menu-item-has-children a").click(function(e) {
    $(this)
      .parent()
      .addClass("sub-opened");
    $(this)
      .parents("#mobile-menu")
      .addClass("sub-open");
  });
  $(".close-sub .mobile-menu-item").click(function(e) {
    $(this)
      .parents(".sub-opened")
      .removeClass("sub-opened");
    $(this)
      .parents("#mobile-menu")
      .removeClass("sub-open");
  });
  $("[aria-current='page']").click(function(e) {
    $("#mobile-nav").removeClass("mobile-menu-open");
    $("#menu-toggle").removeClass("toggled");
    $(this)
      .parents(".sub-opened")
      .removeClass("sub-opened");
    $(this)
      .parents("#mobile-menu")
      .removeClass("sub-open");
  });

  $map = $("#car-container");
  $autoSolutions = $("#automotive-solutions");

  $(".trigger").hover(function() {
    $trigger = $(this).attr("data-trigger");
    $part = $("#" + $trigger);
    $($part).toggleClass("part-hovered");
  });

  $(".trigger").click(function(e) {
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $autoSolutions.offset().top - 48,
        },
        850,
        // include easing.js for more control over ease
        "easeInOutQuint"
      );

    $trigger = $(this).attr("data-trigger");
    $tooltip = $("[data-tooltip='" + $trigger + "']");
    $part = $("#" + $trigger);
    $($part).toggleClass("part-active");

    if ($(this).hasClass("part-open")) {
      $(this).removeClass("part-open");
      $($part).removeClass("part-active");
      $tooltip.removeClass("tooltip-open");
    } else {
      $(this).addClass("part-open");
      $(this)
        .siblings()
        .removeClass("part-open");
      $tooltip.addClass("tooltip-open");
      $tooltip.siblings().removeClass("tooltip-open");
      $part.addClass("part-active");
      $part.siblings().removeClass("part-active");
    }
  });
  const videoElement = document.getElementById("head-video");
  if (videoElement) {
    $("body").on("click touchstart", function() {
      if (videoElement.playing) {
        // video is already playing so do nothing
      } else {
        // video is not playing
        // so play video now
        videoElement.play();
      }
    });
  }
});
